export default "__VITE_ASSET__DOMaYma8__"